const BIG_NUMBER = 1000000000000;

const suid = () => {
    const time = `0${Date.now().toString(36)}`;
    let random = Math.floor(Math.random() * BIG_NUMBER).toString(36);

    random = random.padStart(8, '0');
    return `${time}-${random}`;
};

export default suid;
